import { FC } from "react";
import { ChatBubble } from "./ChatBubble";
import { ChatPopup } from "./ChatPopup";
import { useChatWidget } from "./useChatWidget";
import "./ChatWidget.scss";

// Mounted once in MasterLayout.tsx, outside <Outlet/>, so it persists across
// route changes without needing a Context/Provider — MasterLayout itself
// isn't remounted on navigation, only its routed child swaps.
const ChatWidget: FC = () => {
  const { open, toggleOpen, messages, sending, awaitingConfirmation, unreadCount, autoListenSignal, sendMessage } =
    useChatWidget();

  return (
    <div className="chat-widget-root">
      {open && (
        <ChatPopup
          messages={messages}
          sending={sending}
          awaitingConfirmation={awaitingConfirmation}
          autoListenSignal={autoListenSignal}
          onSend={sendMessage}
        />
      )}
      <ChatBubble open={open} unreadCount={unreadCount} onToggle={toggleOpen} />
    </div>
  );
};

export { ChatWidget };
